export default __webpack_public_path__ + "static/media/Reveal_logo_400.040c72ca.png";